import styled from 'styled-components'

import Button from '@/components/Button'
import { headerClrDark, headerClrLight } from '@/const/colors'
import { WidthBPs } from '@/const/commonStyles'

export const StyledHeader = styled.header`
  background: linear-gradient(218.47deg, ${headerClrLight} -74.13%, ${headerClrDark} 106.5%);
  width: 100%;
  height: 50px;
`

export const LogoAuthWrapper = styled.div`
  height: 24px;
  display: flex;
  align-items: center;
`

export const LogoWrapper = styled.div`
  padding-left: 24px;
  height: 24px;
  display: flex;
  align-items: center;
`

export const Container = styled.div`
  display: grid;
  align-items: center;
  grid-template-columns: 173px 1fr;
  grid-template-areas: 'logo profile';

  width: 100%;
  height: 100%;

  margin: 0 auto;
  padding: 0 23px 0 0;

  @media (min-width: ${WidthBPs.MEDIUM}) {
    grid-template-columns: 239px 50% 1fr;
  }
`

export const ButtonBlock = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  justify-content: flex-end;
  align-items: center;
`

export const ButtonGroup = styled.div`
  display: flex;
  align-items: center;
  margin-left: 14px;
`

export const NavBlock = styled.div`
  display: flex;
  align-items: center;
`

export const HeaderIconButton = styled(Button)`
  height: 32px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0;
  background: rgba(255, 255, 255, 0.1);
  border: none;
  flex-shrink: 0;
  width: 42px;
  margin-right: 14px;
  stroke: none;

  &:hover:not(:disabled) {
    background: rgba(255, 255, 255, 0.14);
    stroke: none;
  }

  &:focus:not(:disabled) {
    background: rgba(255, 255, 255, 0.18);
    stroke: none;
  }

  &:hover:not(:disabled),
  &:focus:not(:disabled) {
    transform: none;
  }

  &:last-child {
    margin-right: 0;
  }
`

export const IconButton = styled(Button)`
  height: 28px;
  width: 28px;
  padding: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: transparent;
  border: none;
  flex-shrink: 0;
  margin-left: 21px;
  fill: none;
  stroke: none;

  & svg {
    flex-shrink: 0;
    background-color: transparent;
  }

  &:hover:not(:disabled),
  &:focus:not(:disabled) {
    transform: none;
    fill: none;
    stroke: none;
  }
`

export const BurgerButtonWrapper = styled.div`
  width: 65px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`

export const BurgerButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  background-color: transparent;
  outline: none;
  border: none;
  cursor: pointer;

  & svg {
    flex-shrink: 0;
  }
`
